var _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileFormatOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5980_7935",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 14,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8.5C4.22386 8.5 4 8.72386 4 9C4 9.27614 4.22386 9.5 4.5 9.5H11.5C11.7761 9.5 12 9.27614 12 9C12 8.72386 11.7761 8.5 11.5 8.5H4.5Z",
    fill: "#000001"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.5C4 6.22386 4.22386 6 4.5 6H11.5C11.7761 6 12 6.22386 12 6.5C12 6.77614 11.7761 7 11.5 7H4.5C4.22386 7 4 6.77614 4 6.5Z",
    fill: "#000001"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 11C4.22386 11 4 11.2239 4 11.5C4 11.7761 4.22386 12 4.5 12H11.5C11.7761 12 12 11.7761 12 11.5C12 11.2239 11.7761 11 11.5 11H4.5Z",
    fill: "#000001"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3996 3.98324L10.9165 0.571283C10.5427 0.205094 10.0403 0 9.51696 0H4C2.34315 0 1 1.34315 1 3V13C1 14.6569 2.34315 16 4 16H12C13.6569 16 15 14.6569 15 13V5.41196C15 4.87438 14.7836 4.35943 14.3996 3.98324ZM2 13V3C2 1.89543 2.89543 1 4 1H9.51696C9.77861 1 10.0298 1.10255 10.2167 1.28564L13.6998 4.6976C13.8918 4.8857 14 5.14317 14 5.41196V13C14 14.1046 13.1046 15 12 15H4C2.89543 15 2 14.1046 2 13Z",
    fill: "#000001"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5980_7935)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#131619"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileFormatOutlined);
export default __webpack_public_path__ + "static/media/file-format-outlined.80dcd45a3cf3365ed7fb8a51982dedb8.svg";
export { ForwardRef as ReactComponent };